import {ofType} from 'redux-observable';
import {Observable} from 'rxjs';
import {map, catchError, flatMap} from 'rxjs/operators';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import {showDeleteDialogObservable} from 'web-app/react/dialog';

import * as Actions from './actions';
import * as Api from './api';

const fetch = action$ =>
    action$.pipe(
        ofType(Actions.fetch.type),
        flatMap(({payload}: ReturnType<typeof Actions.fetch.action>) => {
            const {institutionId, billPayerId} = payload;

            return Api.fetch(institutionId, billPayerId).pipe(
                map(({credits, behaviors}) => {
                    return Actions.fetchSuccess.action(institutionId, billPayerId, credits, behaviors);
                }),
                catchError(e => Observable.of(Actions.fetchFailed.action(e))),
            );
        }),
    );

const create = action$ =>
    action$.pipe(
        ofType(Actions.create.type),
        flatMap(({payload}: ReturnType<typeof Actions.create.action>) => {
            const {institutionId, billPayerId, credit} = payload;

            return Api.create(institutionId, billPayerId, credit).pipe(
                map(credit => Actions.createSuccess.action(institutionId, billPayerId, credit)),
                catchError(e => Observable.of(Actions.createFailed.action(e))),
            );
        }),
    );

const update = action$ =>
    action$.pipe(
        ofType(Actions.update.type),
        flatMap(({payload}: ReturnType<typeof Actions.update.action>) => {
            const {institutionId, credit} = payload;

            return Api.update(institutionId, credit).pipe(
                map(credit => Actions.updateSuccess.action(credit)),
                catchError(e => Observable.of(Actions.updateFailed.action(e))),
            );
        }),
    );

const remove = action$ =>
    action$.pipe(
        ofType(Actions.deleteCredit.type),
        flatMap(({payload}: ReturnType<typeof Actions.deleteCredit.action>) => {
            return showDeleteDialogObservable({
                title: '',
                description: i18next.t('childProfile.credits.confirmCreditDelete'),
            }).pipe(
                flatMap(selection => {
                    const {institutionId, credit} = payload;

                    if (selection === 'OK') {
                        return Api.remove(institutionId, credit).pipe(
                            map(creditId => Actions.deleteCreditSuccess.action(creditId, payload.credit.billPayerId)),
                            catchError(e => Observable.of(Actions.deleteCreditFailed.action(e))),
                        );
                    } else {
                        return Observable.of(Actions.deleteCreditAborted.action());
                    }
                }),
            );
        }),
    );

export default combineEpics(fetch, create, update, remove);
